<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '60vw' }" [closable]="true" (onHide)="onClose()">
  <ng-template pTemplate="header">
    <h3 class="titulo-dialogo border-b-2 w-full">{{ title }}</h3>
  </ng-template>

  <ng-template pTemplate="content">
    <p-table [value]="data" [columns]="column" [paginator]="true" [rows]="rows" [first]="first" [rowsPerPageOptions]="[10, 25, 50]" (onPage)="onPageChange($event)">
      <!-- Columnas -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>{{ col.header }}</th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          @for (col of columns; track col) {
            <td>
              @if (col.field === 'estado') {
                <p-tag [value]="row[col.field]" [severity]="stateTag(row[col.field])" />
              } @else {
                {{ row[col.field] }}
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>